import { render, staticRenderFns } from "./formScreenTYpage.vue?vue&type=template&id=767f3b22&scoped=true"
import script from "./formScreenTYpage.vue?vue&type=script&lang=js"
export * from "./formScreenTYpage.vue?vue&type=script&lang=js"
import style0 from "./formScreenTYpage.vue?vue&type=style&index=0&id=767f3b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767f3b22",
  null
  
)

export default component.exports